import { jsxs as a, jsx as o } from "react/jsx-runtime";
import { TransformationImageCardCarousel as n } from "../TransformationImageCardCarousel/index.js";
import { MadeWithSimplyReview as C } from "../SimplySignature/index.js";
function A(r) {
  var t, R;
  return /* @__PURE__ */ a("div", { children: [
    /* @__PURE__ */ o(
      n,
      {
        transformations: r.transformations,
        textCardBackgroundColor: (t = r.config) == null ? void 0 : t.textCardBackgroundColor,
        hasControls: (R = r.config) == null ? void 0 : R.hasControls
      }
    ),
    /* @__PURE__ */ o("div", { style: { width: "100%", display: "flex", justifyContent: "center" }, children: /* @__PURE__ */ o(C, {}) })
  ] });
}
var E = /* @__PURE__ */ ((r) => (r.MICRO_STARS = "MICRO_STARS", r.HEADER_BAR_STARS = "HEADER_BAR_STARS", r.REVIEW_CARDS = "REVIEW_CARDS", r.BEFORE_AFTER_CARDS = "BEFORE_AFTER_CARDS", r.VIDEO_CARDS = "VIDEO_CARDS", r.TEXT_VIDEO_CARDS = "TEXT_VIDEO_CARDS", r))(E || {}), _ = /* @__PURE__ */ ((r) => (r.left = "left", r.right = "right", r.center = "center", r))(_ || {});
export {
  _ as Alignment,
  A as TransformationImageCardsCarouselWidget,
  E as WidgetType
};
